const TAGS = Object.freeze({
    IMAGE_PLACEHOLDER: "image_placeholder",
    IMAGE_RESOURCE: "image_resource",
    MAIN_LAYER: "mainLayer",
    PRESENTER_LAYER: "presenterLayer",
    LAYOUT: "layout",
    BACKGROUND_GROUP: "backgroundGroup",
    TEXTBOX: "textbox",
    PAGE_MAIN_BACKGROUND: "pageMainBackground",
    PASSE_PARTOUT: "passePartout",
    ALTER_BADGE: "alert_badge",
    BASE_ICON: "base_icon",
    ACTIVE_ICON: "active_icon"
});
const MODE = Object.freeze({
    CLIENT: "Client",
    DESIGN: "Design",
    RENDER: "Render",
    PREVIEW: "Preview"
});

class IconsRepository {

    /**
    * @private
    * @type {Set<void>}
    * Przekazane z obiektu nadrzędnego, lista jego sygnałów do obsługi przerwania działania komponentu.
    *
    */
    abortHandler;
    constructor(abortHandler) {
        this.abortHandler = abortHandler;
    }

    /**
     * Pobiera ikonę z repozytorium ikon, jeśli nie jest jeszcze załadowana, ładuje ją.
     * @param {string} key
     */
    async getIconFromRepo(key) {
        if (!this[key]) {
            this[key] = new Promise((resolve, reject) => {
                var img = new Image();
                img.onload = () => { this.abortHandler.delete(onAbort); resolve(img);} // promise zwraca img po zakończeniu 

                // Funkcja anulowania dla tej instancji ładowania
                const onAbort = () => {
                    //console.log("Aborted image loading" + img.src);
                    img.src = ""; // Czyści źródło obrazu, co powoduje przerwanie wczytywania
                    reject(); // potencjalni porządany efekt --> Promise.all się przerwie
                };

                // Dodaj funkcję anulowania do zestawu
                this.abortHandler.add(onAbort);

                img.src = `_content/PixelTech.Konva/image/${key}`;
            });
        }
        return this[key];
    }
}
export { TAGS, MODE, IconsRepository };